<template>
  <el-card class="box-card full-screen recharge-apply">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('phone')">
          <phone-input
            v-model="queryForm.phoneNo"
            size="small"
            @phone-input="onPhoneInput"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="selection"
          fixed="left"
          width="50"
        ></el-table-column>

        <el-table-column
          prop="customerName"
          fixed="left"
          :label="$t('customer')"
          width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.customerName }} {{ scope.row.customerSurname }}
          </template>
        </el-table-column>
        <el-table-column prop="customerPhone" :label="$t('phone')" width="160">
          <template slot-scope="scope">
            {{ scope.row.customerPhone }}
          </template>
        </el-table-column>

        <el-table-column
          prop="deviceName"
          :label="$t('deviceName')"
          width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.deviceName }}
          </template>
        </el-table-column>

        <el-table-column prop="deviceOs" :label="$t('OS')" width="160">
          <template slot-scope="scope">
            {{ scope.row.deviceOs }}
          </template>
        </el-table-column>
        <el-table-column prop="bindTime" :label="$t('Bind Time')" width="180">
          <template slot-scope="scope">
            {{ $manba(scope.row.bindTime).format("ymdhms") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="lastLoginTime"
          :label="$t('Last Login')"
          width="160"
        >
          <template slot-scope="scope">
            {{
              scope.row.lastLoginTime
                ? $manba(scope.row.lastLoginTime).format("ymdhms")
                : "-"
            }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('extend')" fixed="right" width="160">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="unbindDevice(scope.row)"
            >
              {{ $t("unbind") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t(applyTitle)"
      :visible.sync="isCheckApply"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="checkForm" :rules="rules" ref="checkForm">
        <el-divider content-position="left">{{ $t("applyInfo") }}</el-divider>
        <el-form-item :label="$t('Customer')">
          <el-input
            size="medium"
            v-model="applyForm.customerName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('Device')">
          <el-input
            size="medium"
            v-model="applyForm.deviceName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('OS')">
          <el-input
            size="medium"
            v-model="applyForm.deviceOs"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('Bind Time')" prop="bindTime">
          <el-input
            size="medium"
            v-model="applyForm.bindTime"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('Last Login')" prop="lastLoginTime">
          <el-input
            size="medium"
            v-model="applyForm.lastLoginTime"
            disabled
          ></el-input>
        </el-form-item>
        <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>
        <el-form-item :label="$t('checkStatus')" prop="status">
          <el-radio v-model="checkForm.status" :label="0" border>{{
            $t("unbindDevice")
          }}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('reason')" prop="reason">
          <el-input
            type="textarea"
            size="medium"
            v-model="checkForm.reason"
          ></el-input>
        </el-form-item>
        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitCheckResult('checkForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import customerDevice from "@/api/customer.device";
import PhoneInput from "@/components/PhoneInput";

export default {
  name: "unbindDevices",
  components: {
    PhoneInput
  },
  data() {
    return {
      isLoading: false,
      //table高度，动态设置
      queryTableHeight: String,
      //table显示内容
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,

      queryForm: {
        phoneNo: "",
        phoneRaw: ""
      },
      //是否显示审核申请弹框
      isCheckApply: false,
      //弹框标题
      applyTitle: "unbindDevices",

      //申请表单
      applyForm: {},
      //审核表单
      checkForm: {},
      orgList: []
    };
  },
  computed: {
    rules() {
      return {
        status: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    },
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    }
  },
  methods: {
    getList() {
      let _this = this;
      _this.isLoading = true;
      customerDevice.getPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm
        },
        success: res => {
          _this.isLoading = false;
          _this.tableData = res.data || {};
        }
      });
      _this.isLoading = false;
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    unbindDevice(row) {
      this.applyForm = {
        ...row,
        bindTime: row.bindTime
          ? this.$manba(row.bindTime).format("ymdhms")
          : "-",
        lastLoginTime: row.lastLoginTime
          ? this.$manba(row.lastLoginTime).format("ymdhms")
          : "-",
        customerName:
          (row.customerName || "") + " " + (row.customerSurname || "")
      };
      this.checkForm = {
        id: row.id,
        //status: 0,
        reason: ""
      };
      this.isCheckApply = true;
    },

    /**提交充值申请 */
    onSubmitCheckResult(refName) {
      this.$refs[refName].validate(valid => {
        if (!valid) return false;
        this.isLoading = true;
        customerDevice.unBindDevice({
          param: {
            customerId: this.applyForm.customerId,
            reason: this.checkForm.reason
          },
          success: res => {
            this.isLoading = false;
            if (res.code == 200) {
              this.$message.success(this.$t("operateSuccessfully"));
              this.isCheckApply = false;
              this.getList();
            } else {
              this.$message.warning(this.$t(res.msg));
            }
          }
        });
      });
    }
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.recharge-apply {
  #org-info-from {
    .el-col-8 {
      margin-bottom: 31px;
    }
  }

  .testes {
    animation: identifier 300ms;
  }
  @keyframes identifier {
    0% {
      height: 0px;
    }
    100% {
      height: 100px;
    }
  }
}
</style>
